/* eslint-disable max-len */
export default {
  lang: 'French',
  homeScreen: {
    title: 'Découvrez des grandes choses',
    stayConnected: 'Restez connecté',
    comingSoon: 'Disponible bientôt',
    messages: 'Messages',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Saisissez l'adresse électronique que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        "Aucun compte n'a été trouvé ({email}), veuillez essayer avec un autre email ou créer un compte maintenant.",
      continueButton: 'Continuer',
      success:
        "La mise à jour de votre compte a été effectuée avec succès ! Vous serez bientôt redirigé vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un courriel de confirmation pour vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound:
        'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink:
        "Connectez-vous à l'aide d'un lien figurant dans votre courrier électronique :",
      magicLinkButton: 'Demande de lien magique',
      magicLinkTitle:
        'Un lien direct vous est envoyé par e-mail pour vous permettre de vous inscrire instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      titleIndustry:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: "Visiteur de l'industrie",
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        "Êtes-vous sûr de ne pas vouloir rester en contact avec l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'LES PRÉFÉRENCES EN MATIÈRE DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de TravPRO Mobile en matière de réseautage et d'aide à la vente pour les professionnels du voyage.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons pas, n'utilisons pas à mauvais escient et ne trahissons pas votre confiance.",
      store:
        "Téléchargez facilement ce programme dans votre magasin d'applications :",
      powered: 'ALIMENTÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
        magicLinkMessage:
          'Veuillez patienter, nous sommes en train de vous inscrire.',
        magicLinkError:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas trouvé de jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, veuillez nous contacter à l'adresse suivante : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess:
          "Consultez votre courrier électronique à l'adresse {email}. Il contient un lien magique qui vous permettra de vous connecter.",
        magicLinkErrorWait:
          'Veuillez attendre 5 minutes entre les demandes de liens magiques.',
        emailNotFoundError:
          "L'adresse électronique que vous avez saisie ne figure pas dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'ZipCode ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe saisis ne correspondent pas',
        passwordTooShort:
          'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          "Cette adresse électronique existe déjà ou n'est pas valide. Veuillez essayer avec une autre adresse électronique ou vous connecter à votre compte.",
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez indiquer votre adresse électronique.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy:
          'Vous avez oublié votre mot de passe et souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous voulez éviter le mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme.',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description:
          "Laquelle décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisissez un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: "Nom de l'agence",
        title: 'Votre rôle (Sélectionnez un rôle)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate:
          'Quel est le groupe auquel vous êtes PRINCIPALEMENT affilié ?',
        hostAgency: "Votre agence d'accueil ?",
        executive: 'Cadre',
        management: 'Gestion',
        marketing: 'Marketing',
        sales: 'Vente',
        coordinator: 'Coordinateur',
        opt: "Restez en contact avec l'équipe commerciale de ce programme et recevez des mises à jou",
        optMarketing:
          'Restez en contact avec TravPRO en ce qui concerne les programmes et événements similaires.',
        retail: "Façade d'un magasin de détail",
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: "Agence d'accueil",
        call: "Centre d'appel ou agence en ligne",
        other: 'Autres',
        describes:
          "Qu'est-ce qui décrit le mieux votre activité et celle de votre agence ?",
      },
    },
    title: 'Formation pour les professionnels du tourisme',
    forgot: 'Mot de passe oublié ?',
    forgotCopy:
      "Veuillez fournir l'adresse e-mail que vous avez utilisée lors de votre inscription à votre compte Finland Travel PRO. Nous vous enverrons un e-mail qui vous permettra de réinitialiser votre mot de passe.",
    country: 'Pays / Région *',
    select: 'Veuillez sélectionner une option ci-dessous',
    theme: 'Quel est le THÈME PRODUIT que vous vendez principalement ? *',
    type: 'Quel est le THÈME PRODUIT que vous vendez principalement ? *',
    businessType: "Type d'entreprise *",
    welcome: {
      headerTop: 'Bienvenue à',
      headerBottom: 'Finland Travel Pro',
    },
    sellingPoints: {
      0: 'Apprenez, promouvez et vendez ',
      1: 'Formation multimédia pour différents supports',
      2: 'Certificat de finalisation',
      3: 'Présentations des ventes ',
      4: 'Materiel promotionel à forte efficacité',
      5: "Conseils & Promotions d'experts",
      6: 'Répertoire des produits',
      7: 'Nouvelles & Mises a jours',
    },
    emailPrompt:
      'Veuillez insérer votre adresse email et le mot de passe pour confirmer que vous êtes un professionnel du tourisme',
    tAndC: {
      agree: 'En continuant vous acceptez notre',
      privacyPolicy: ' politique de confidentialité ',
      and: 'et',
      termsConditions: ' conditions générales de vente',
    },
    fields: {
      agency: 'Agence',
      email: 'Email',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      city: 'Ville',
      agencyName: "Nom de l'agence",
      stateProvince: 'Région',
      required: 'Obligatoire',
      invalidEmail: 'Adresse email invalide',
      opt: "Restez en contact! Oui, je voudrais recevoir l'information de la part de Finland Travel Pro concernant les nouvelles, évènements, famtrips, incentives et autre!",
      forgot:
        'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    },
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: 'Merci pour votre interêt pour Finland Travel Pro.',
      messageWeb:
        'Le contenu sur ce site est réservé exclusivement aux professionnels du tourisme. Pour savoir plus sur la Finlande, veuillez cliquer:',
      messageMobile:
        'Une partie du contenu dans cette application est réservée exclusivement aux professionnels du tourisme, mais vous pouvez aussi visualier un apercu de ce que ce site peut vous offrir en cliquant sur Continuer.',
      continue: 'Continuez',
      visitWebsite: 'Visitez le site web',
    },
    newUser: 'Nouvel utilisateur',
    register: "S'inscrire",
    registered: 'Cette adresse email est déjà enregistrée',
  },
  welcomeScreen: {
    title: 'Bienvenue à Finlande Travel Pro',
    helloUser: 'Bonjour {nom}}',
    hello: 'Bonjour,',
    fromAgency: 'par (agence)',
    notUser: 'Non {{nom}}?',
    introOnline:
      "Entrainez vous immédiatement en ligne ou téléchargez le contenu pour l'utiliser hors connexion!",
    introOffline:
      'Vous avez déjà téléchargé la dernière version disponible. Commencez à vous former et à vendre  où vous voulez et quand vous voulez!',
    startTraining: 'Commencez à apprendre',
    continueTraining: 'Continuez à apprendre',
    graduated: 'Félicitations!',
    downloader: {
      preload: 'Télécharger',
      stop: 'Arrêtez',
      init: 'Initialisation…',
      lastUpdate: 'Dernière mise à jour:',
    },
  },
  contactView: {
    regions: {
      europe: "L'Europe",
      northAmerica: 'Amérique du Nord',
      asiaPacific: 'Asie Pacifique',
      fcb: 'FCB - Finland Convention Bureau',
    },
    jobTitles: {
      salesMarketing: 'Responsable Ventes & Marketing',
      directorVisitFinland: 'Directeur de Visit Finland (Dach & Benelux)',
      specialist: 'Spécialiste',
      accountManager: 'Gestionnaire de compte',
      advisor: 'Conseiller',
      headVisitFinlandNorthAmerica: 'Chef de Visit Finland Amérique du Nord',
      managerBusinessEvents: "Gestionnaire, Événements d'affaires",
      seniorBusinessEvents: "Spécialiste sénior des événements d'affaires",
    },
    countries: {
      gbIreland: 'Grande-Bretagne et Irlande',
      spainItaly: 'Espagne & Italie',
      france: 'France',
      westEurope: 'Allemagne, Autriche, Suisse, Belgique, Pays-Bas, Luxembourg',
      benelux: 'Dach, Benelux',
      rusiaCISBaltics: 'Russie (Saint-Pétersbourg), CIS and Pays baltes',
      rusiaCIS: 'Russie & CIS',
      northAmerica: 'Amérique du Nord',
      japan: 'Japon',
      chinaSEAsia: 'Chine & Asie du sud est',
      southKorea: 'Corée du Sud',
      india: 'Inde & UAE',
      australia: 'Australie',
    },
  },
  trainingScreens: {
    start: 'Commencez',
    continue: 'Continuez  ',
    review: 'Révisez',
    restart: 'Recommencez',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% terminé',
    unlock: 'Déverouillez ce chapitre en terminant le chapitre x.',
    unlockSubtitle:
      'Déverouillez plus de chapitres en terminant les chapitres de formation.',
    allUnlocked: 'Vous avez déverouillez tous les chapitres!',
    certificate: 'Cértificat',
    courseComplete: 'Continuez',
    endReached: 'Vous avez terminé la formation',
    retainEnd:
      'Utilisez la barre au-dessus pour naviguer dans ce chapitre ou appuyez sur le bouton retour pour révenir au sommaire.',
    watchListenRead: 'Regardez, écoutez et lisez plus',
    trouble:
      'Il semble que vous avez un problème, veuillez relire le contenu de la page précédente et éssayez de nouveau',
    confirm: 'Confirmez votre réponse',
    choose: 'Veuillez choisir une réponse',
    skip: 'Retour >',
    viewAllTitle: 'Conseil de formation',
    viewAll:
      "Afin d'accéder à la page suivante, veuillez cliquer sur les icônes pour voir le contenu supplémentaire. Vidèos, cartes et autres informations utiles sont fournis pour vous aider dans votre formation et confirmer votre niveau PRO. ",
    fillBlanks: 'Veuillez remplir le blanc',
    next: 'Prochaine question',
    retry: 'Essayez de nouveau',
    fastTrackText: {
      success:
        'Félicitations, vous avez terminé le cours Fast Track et débloqué le reste de la formation!',
      failed:
        "Malheuresement vous n'avez pas terminé le cours Fast Track, vous pouvez reprendre la formation pour obtenir le cértificat!",
    },
    fastTrack: 'Devenez un superstar Finland Travel Pro!',
    fastTrackExplanation: 'Simplement ',
    fastTrackButton: 'Cliquez ici pour faire le quiz',
    grading: 'Votre note finale est: %',
  },
  nav: {
    home: 'Accueil',
    train: 'Entrainez-vous',
    learn: 'Apprenez',
    retain: 'Retenez',
    directory: 'Répertoire  ',
    showRoom: 'Vitrines',
    showcases: 'Vitrines',
    promote: 'Promouvez',
    sell: 'Vendez',
    info: 'Information',
    rewards: 'Récompense',
    media: 'Média',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Voir le diplôme',
    accountSettings: 'Paremètres du compte',
    messages: 'Messages',
    search: 'Recherche',
  },
  contentHeaders: {
    train: 'Apprenez',
    retain: 'Retenez',
    subapps: 'Modules des  partenaires de Visit Finland',
    maintrainings: 'Les fondements',
    subtrainings: 'Modules de spécialisation',
  },
  pageDescriptions: {
    train: 'Formez vous, engagez vous et devenez un expert',
    showroom: '',
    retain:
      "Votre source d'information pour rafraichir vos connaissances d'expert et vous aider dans vos efforts de ventes. Utiliser cette espace pour répondre professionnellement à une question sur un produit ou à une question inattendu à propos de la presentation de ventes -  à tout moment, partout et sur tous supports.",
    promote:
      "Partagez ces sujets pour réveiller l'intêret et commencez un échange avec les clients et prospects. ",
    sell: 'Répondez aux questions des clients et concluez les ventes comme un professionnel possédant une connaissance approfondie et des supports de ventes ciblés. ',
    favorites: 'Vérifiez votre contenu favoris',
    search: 'Parcourez tous les contenus',
    subapps: '',
    maintrainings:
      'Terminez ces modules essentiels pour obtenir votre cértificat',
    subtrainings: 'Apprenez-en sur les produits spécifiques',
  },
  general: {
    viewBadge: 'Vue',
    viewBadge2: 'Insigne',
    back: 'Retour',
    next: 'Prochaine',
    yes: 'Oui',
    no: 'Non',
    previous: 'Précédent',
    page: 'Page',
    search: 'Recherche',
    logIn: 'Se connecter',
    logOut: 'se déconnecter',
    viewItem: 'Montrer {type}',
    imageNotFound: 'Image non trouvée',
    noResultsFor: 'Aucun rédultat trouvé pour: ',
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez pas encore recu de messages!",
    resultsFor: 'Les résultats pour: ',
    showAll: 'Montrer tout',
    connectionError: 'Erreur de connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 page non trouvé !',
    oops: 'Oups…',
    overview: 'Retourner au sommaire',
    complete: 'Continuer',
    courseComplete: 'Chapitre terminé!',
    chapterComplete: 'Chapitre terminé!',
    message: 'Message',
    messagePlural: 'Messages',
  },
  itemTypes: {
    image: 'Image   ',
    brochure: 'Collection',
    layout: 'Mise en page',
    web: 'Le site web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Tournez les boutons pour trouver la correspondance',
    fitb: 'Veuillez remplir le blanc',
    flip: 'Changez le numéro pour trouver la correspondance',
    multipleChoice: 'Sélectionnez la bonne réponse',
    slider: 'Sélectionnez la bonne réponse en utilisant le curseur',
    map: 'Répondez à la question en tapant sur le bon emplacement sur la carte',
    dropdown: 'Choisissez…',
    true: 'Vrai',
    false: 'Faux',
  },
  reportCard: {
    download: 'Télécharger',
    email: 'Email',
    print: 'Imprimer',
  },
  cookies: {
    consent: "Être d'accord",
    optout: 'Exclure',
    settings: 'politique de confidentialité',
    message:
      'Vous ne nous avez pas annoncé vos préférences de confidentialité! ',
    disabled:
      "Il semblerait que vous avez désactiver l'utilisation des cookies.",
    use: "Le éxige l'utilisation des cookies pour une meilleure experience. ",
    details: 'Pour quelles raisons les cookies sont utilisés ?',
    enable: 'Comment activer vos cookies "ici"',
    here: 'Voici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connectés",
    title: 'Vous devez vous connecter pour visualier le contenu',
    guest: 'Invité',
  },
  demo: {
    message:
      "Ce site web est une démo du produit final. Il est actuellement en développement et n'est pas un produit fini.",
    consent: 'Compris!',
  },
  share: {
    header: 'Partagez cette resource dans votre réseau social préféré !',
    download: 'Télécharger',
  },
  sharing: {
    copyURL: 'Copier le lien',
    copied: 'Copié',
    emailSubject: 'Une ressource finlandaise',
    emailCopy:
      "J'espère que vous apprécierez cette ressource finlandaise. Veuillez nous contacter et commençons à planifier votre prochain voyage!",
    videoEmailSubject: 'Profitez de cette vidéo sur la Finlande',
    videoEmailCopy:
      "J'espère que vous apprécierez cette vidéo sur la Finlande. Veuillez nous contacter et commençons à planifier votre prochain voyage!",
    imageEmailSubject: 'Profitez de cette image de la Finlande',
    imageEmailCopy:
      "J'espère que vous apprécierez cette image de la Finlande. Veuillez nous contacter et commençons à planifier votre prochain voyage!",
    twitterCopy: 'Découvrez de grandes choses en Finlande',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      'Il semblerait que vous essayez d\'accéder à "Nom App" depuis votre mobile.',
    body: "Pour télécharger ce programme visitez votre boutique d'applications et recherchez pour ou cliquez un des boutons ci-dessous.",
    benefits: {
      1: 'Apprenez, promouvez et vendez ',
      2: 'Formation multimedia pour différents supports',
      3: 'Cértificat de finalisation',
      4: 'Les présentations  de vente clés-en-main.',
      5: 'Materiel promotionel à fort rendement',
      6: 'Répertoire de produits en temps réel',
      7: 'Nouvelles et mises à jour',
      header: 'Cela vous donne: ',
    },
  },
  custom: {
    splitUsers: 'Je suis…',
    brandAmbassador: 'ambassadeur de marque',
    travelPro: 'Professionel du tourisme',
  },
  directoryFilters: {
    cities: 'Filtrer par Ville',
    search: 'Rechercher un produit',
    type: 'Filtrer par Type de Produit',
    reset: 'Réinitialiser les Filtres >',
    tags: 'Filtrer par Étiquettes',
    months: 'Filtrer par Saison',
    noResults: 'Aucun Résultat Trouvé',
    targetGroups: 'Filtrer par Groupe Cible',
    additional: 'Filtres Supplémentaires:',
    sustainable: 'Voyage Durable Finlande',
    accessible: 'Accessible',
    results: 'Résultats',
  },
  directory: {
    city: 'Filtrer par ville',
    search: 'Rechercher un produit',
    product: 'Filtrer par type de produit',
    reset: 'Réinitialiser les filtres >',
    category: 'Filtrer par catégorie',
    season: 'Filtrer par saison',
    noResults: 'Aucun résultat trouvé',
    target: 'Filtrer par groupe cible',
    additional: 'Filtres supplémentaires',
    sustainable: 'Sustainable Travel Finland',
    accessible: 'Accessible',
    results: 'Résultats',
  },
  submit: 'Soumettre',
  back: 'Retour',
  close: 'Fermez',
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
};
